import { Link } from 'react-router';
import { Menu } from 'lucide-react';
import { DarkModeToggle } from '@/components/ui/dark-mode-toggle';
import { JennyLogo } from '@/components/JennyLogo';
import { HelpMenu } from './HelpMenu';
import { useAuth } from '@/hooks/use-auth';
import { useMobileSidebar } from './MobileSidebarContext';
import { ROUTES } from '@/lib/routes';
import boschLogoUrl from '../../../Assets/Bosch_logo.svg';

export function Header() {
  const { user, logout } = useAuth();
  const { toggle } = useMobileSidebar();

  const displayName = user?.name ?? user?.email ?? user?.username ?? '';

  return (
    <header className="flex h-14 shrink-0 items-center justify-between border-b border-[var(--border-default)] bg-[var(--bg-primary)] px-2 md:px-4 z-50">
      <div className="flex items-center gap-1">
        <button
          type="button"
          onClick={toggle}
          aria-label="Toggle menu"
          className="inline-flex h-10 w-10 md:hidden cursor-pointer items-center justify-center rounded border-none bg-transparent text-[var(--text-primary)] hover:bg-[var(--bg-secondary)] transition-colors"
        >
          <Menu size={22} />
        </button>
        <Link to={ROUTES.APP} className="flex items-center no-underline ml-3 md:ml-6">
          <JennyLogo className="h-9" />
        </Link>
      </div>

      <div className="flex items-center gap-1 md:gap-2">
        <HelpMenu />
        <DarkModeToggle />
        {displayName && (
          <span className="ml-1 hidden md:inline text-[length:var(--text-sm)] text-[var(--text-secondary)]">
            {displayName}
          </span>
        )}
        <button
          type="button"
          onClick={() => {
            logout();
          }}
          aria-label="Sign out"
          className="cursor-pointer border-none bg-transparent px-2 py-1 text-[length:var(--text-sm)] text-[var(--text-secondary)] hover:text-[var(--text-primary)] transition-colors hidden sm:inline-flex"
        >
          Sign out
        </button>
        <img src={boschLogoUrl} alt="Bosch" className="h-8 md:h-11" />
      </div>
    </header>
  );
}
